// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__33yzm","label":"styles_label__2fHHS"};